document.addEventListener('DOMContentLoaded', function() {
  // Select the date input field, time slot select, and buttons
  var dateInput = document.querySelector('input[name="properties[Fecha_de_entrega]"]');
  var timeSlotSelect = document.querySelector('select[name="properties[Horario de entrega]"]');
  var addToCartButton = document.querySelector('button[name="add"]'); // Add to Cart button
  var buyNowButton = document.querySelector('button[name="checkout"]'); // Buy Now button
  var errorContainerDate = document.createElement('div'); // Create an element to hold the error message for the date
  var errorContainerTime = document.createElement('div'); // Create an element to hold the error message for the time slot

  // Add styles or class to error message containers
  errorContainerDate.classList.add('error-message');
  errorContainerDate.style.color = 'red'; // Example styling for the date
  errorContainerTime.classList.add('error-message');
  errorContainerTime.style.color = 'red'; // Example styling for the time slot

  // Function to validate if the fields are empty
  function validateFields(event) {
    // Clear previous error messages
    errorContainerDate.textContent = '';
    errorContainerTime.textContent = '';

    var isValid = true; // Flag to track form validity

    // Check if the date input is empty
    if (!dateInput.value) {
      // Prevent form submission if the field is empty
      event.preventDefault();
      isValid = false;

      // Set error message and append it below the date input field
      errorContainerDate.textContent = 'La fecha de entrega es requerida.';
      dateInput.parentElement.appendChild(errorContainerDate);

      // Scroll to the error field for better user experience
      dateInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    // Check if the time slot is still set to the default (first option)
    if (timeSlotSelect.selectedIndex === 0) {
      // Prevent form submission if no time slot is selected
      event.preventDefault();
      isValid = false;

      // Set error message and append it below the time slot select field
      errorContainerTime.textContent = 'El horario de entrega es requerido.';
      timeSlotSelect.parentElement.appendChild(errorContainerTime);

      // Scroll to the error field for better user experience
      if (isValid) {
        timeSlotSelect.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

  // Attach the validateFields function to the "Add to Cart" button
  if (addToCartButton) {
    addToCartButton.addEventListener('click', validateFields);
  }

  // Attach the validateFields function to the "Buy Now" button
  if (buyNowButton) {
    buyNowButton.addEventListener('click', validateFields);
  }

  // Optionally, validate on input change (if you want real-time validation)
  dateInput.addEventListener('input', function() {
    if (dateInput.value) {
      errorContainerDate.textContent = ''; // Clear error when the input is not empty
    }
  });

  timeSlotSelect.addEventListener('change', function() {
    if (timeSlotSelect.selectedIndex !== 0) {
      errorContainerTime.textContent = ''; // Clear error when a valid time slot is selected
    }
  });
});
